import functions from '../functions.js';
import Slider from "../components/Slider";
import { details } from './details';

$(() => {
    detailsTravel.init();
})

const detailsTravel = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: '4,0,0',
        dates: null,
        units: [],
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null
    },
    init() {

        this.$details = $('.object');
        this.params.objectGroupId = this.$details.attr('data-objectgroupid');

        if(! this.$details[0] || this.params.objectGroupId != 6) {
            return;
        }

        this.getParams();


        $('[name="guests"]').val(this.params.guests).trigger('change');

        this.params.objectGroupId = this.$details.attr('data-objectgroupid');
        this.params.objectId = this.$details.attr('data-objectid');
        this.params.calcErrorMessages = $('[data-calcErrorMessages]')[0] ? JSON.parse($('[data-calcErrorMessages]').attr('data-calcErrorMessages')) : null;

        this.$form = $('.object-form');

        this.initDepartureCalendar();

        $('.btn-print').on('click', e => {
            const params = $('.btn-print').attr('data-params');

            if(params) {
                const url = location.protocol + '//' + location.hostname + '/services/itinerary' + params;
                window.open(url, '_blank').focus();
            }
        });

        $('.add-item').on('click', e => {
            let $target = $(e.target);
            $target = $target.attr('data-unitid') ? $target : $target.parents('[data-unitid]');
            let unitId = $target.attr('data-unitid');

            if(detailsTravel.calc[unitId] && details.isBookable(detailsTravel.calc[unitId])) {
                let unitCalc = detailsTravel.calc[unitId].calc;
                let unitTotal = unitCalc.total;
                let totalOld = 0;

                unitCalc.items.forEach(item => {
                    if(item.itemType == 'baseRate') {
                        totalOld += item.itemTotal;
                    }
                });

                this.params.units.push({
                    'unitId': unitId,
                    'total': unitTotal,
                    'totalOld': totalOld > unitTotal ? totalOld : 0,
                });
            }

            detailsTravel.setCalSummary();
        });

        $('body').on('click','.remove-item',function(){
            let $target = $(this);
            $target = $target.attr('data-i') ? $target : $target.parents('[data-i]');
            const idx = $target.attr('data-i');

            detailsTravel.params.units = detailsTravel.params.units.filter((unit, i)=> {
                return i != idx;
            });

            detailsTravel.setCalSummary();
        });

        if($('.details-itinerary-slider')[0]) {
            const itinerarySlider = new Slider($('.details-itinerary-slider'), {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: true,
                initial: 0,
                //arrows: length > perView,
                arrows: true,
            });
        }

        $('[id^=allItinerary]').on('show.bs.collapse', e => {
            $('.show-itinerary').addClass('d-none');
            $('.details-itinerary-slider:not(.keen-slider__created)').each(function (i) {
                new Slider(this, {
                    fade: true,
                    loop: true,
                    arrows: true
                });
            });
        });
        $('[id^=allItinerary]').on('hide.bs.collapse', e => {
            $('.show-itinerary').removeClass('d-none');
        });

        detailsTravel.departureSliderInit();
        detailsTravel.getCalculation();

        $('[name="guests"]').on('change', e => {

            this.params.guests = $(e.target).val();

            functions.setUrlData({
                'dateFrom': this.params.dateFrom,
                'dateTo': this.params.dateTo,
                'guests': this.params.guests
            }, true, true);
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.getCalculation();
        });
    },
    departureSliderInit() {
        if(!detailsTravel.params.dateFrom || ($('[data-departuredate=' + detailsTravel.params.dateFrom + ']').length == 0 && ! detailsTravel.flightDateFrom)) {
           $('li[data-departuredate]').each((i, item) => {
               if(!detailsTravel.params.dateFrom || $('[data-departuredate=' + detailsTravel.params.dateFrom + ']').length == 0) {
                   detailsTravel.params.dateFrom = ! $(item).hasClass('disabled') ? $(item).attr('data-departuredate') : null;
               }
           });
           functions.setUrlData({dateFrom: detailsTravel.params.dateFrom, guests: detailsTravel.params.guests}, true);
       }

       detailsTravel.params.dateTo = $('[data-departuredate=' + detailsTravel.params.dateFrom + ']').attr('data-dateto');

       if(detailsTravel.params.dateFrom && detailsTravel.params.dateTo) {
           $('.units-dates').text(functions.formatDate(detailsTravel.params.dateFrom) + ' - ' + functions.formatDate(detailsTravel.params.dateTo));
       }

       $('li[data-departuredate=' + detailsTravel.params.dateFrom + '][data-dateTo=' + detailsTravel.params.dateTo + ']').addClass('selected');

     let slideActive = 0;
       detailsTravel.slider.$slides.each((index, elem) => {
           if($(elem).hasClass('selected')) {
               slideActive = index;
           }
       });
       detailsTravel.slider.instance.moveToSlide(slideActive, 1);

       const selectedDates = $('li[data-departuredate=' + detailsTravel.params.dateFrom + '][data-dateTo=' + detailsTravel.params.dateTo + ']').attr('data-selecteddates');
       $('.selected-dates').text(selectedDates);
       const arrivalDay = $('li[data-departuredate=' + detailsTravel.params.dateFrom + ']').attr('data-arrivalday');
       $('.arrival-day').text(arrivalDay);

       $('li[data-departuredate]').on('click', e => {
           let $target = $(e.target);

           if(! $target.attr('data-departuredate')) {
               $target = $target.parents('li[data-departuredate]');
               detailsTravel.params.dateFrom = $target.attr('data-departuredate');
           } else {
               detailsTravel.params.dateFrom = $target.attr('data-departuredate');
           }

           detailsTravel.params.duration = $target.attr('data-duration');
           detailsTravel.params.dateTo = $('[data-departuredate=' + detailsTravel.params.dateFrom + ']').attr('data-dateto');

           functions.setUrlData({dateFrom: detailsTravel.params.dateFrom, dateTo: detailsTravel.params.dateTo, guests: detailsTravel.params.guests}, true);

        //    functions.scrollToElement($('#details-units') ,100);
        //    functions.scrollToElement($('#excursions-summary') ,100);

           if(detailsTravel.params.dateFrom && detailsTravel.params.dateTo) {
               $('.units-dates').text(functions.formatDate(detailsTravel.params.dateFrom) + ' - ' + functions.formatDate(detailsTravel.params.dateTo));
           }

           $('li[data-departuredate]').each((i, item) => {
               $(item).removeClass('selected');
           });

           $('li[data-departuredate=' + detailsTravel.params.dateFrom + '][data-dateTo=' + detailsTravel.params.dateTo + ']').addClass('selected');

           let slideActive = 0;
           detailsTravel.slider.$slides.each((index, elem) => {
               if($(elem).hasClass('selected')) {
                   slideActive = index;
               }
           });

           detailsTravel.slider.instance.moveToSlide(slideActive, 1);

           const selectedDates = $('li[data-departuredate=' + detailsTravel.params.dateFrom + '][data-dateTo=' + detailsTravel.params.dateTo + ']').attr('data-selecteddates');
           $('.selected-dates').text(selectedDates);
           const arrivalDay = $('li[data-departuredate=' + detailsTravel.params.dateFrom + ']').attr('data-arrivalday');
           $('.arrival-day').text(arrivalDay);
       });
    },
    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('li').length;
            const perView = 8;

            let slidesPerView = length < perView ? length + 1 : perView;

            $('.booking-calendar-wrapper').addClass('col-lg-' + slidesPerView);

            detailsTravel.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                //arrows: length > perView,
                arrows: true,
                slidesPerView: slidesPerView,
                breakpoints: {
                    '(min-width: 577px) and (max-width: 1024px)': {
                        slidesPerView: 6,
                        controls: true,
                        //arrows: length > 6,
                        //centered: true,
                    },
                    '(max-width: 576px)': {
                        slidesPerView: 2,
                        controls: true,
                        //arrows: length > 2,
                        //centered: true,
                    },
                },
            });
        }
    },
    getParams() {
        this.params = details.getParams(this.params);
    },
    getCalculation(unitId = null) {

        const dateFrom = this.params.dateFrom;
        const dateTo = this.params.dateTo;
        const guests = this.params.guests;
        if(
            (this.params.objectId || unitId)
            && guests
            && dateFrom
            && dateTo
            && this.params.objectGroupId
        ) {

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calculation/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + this.params.objectId)
                + '&guests=' + guests
                + '&dateFrom=' + dateFrom
                + '&dateTo=' + dateTo
                + '&objectGroupId=' + this.params.objectGroupId
                + '&language=' + functions.getLang()
            )
                .done($.proxy(function (response) {

                    //console.log(response);

                    if(response.status) {
                        const data = response.data || [];
                        detailsTravel.calc = data;

                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];

                            const $btnBooking = $('.btn-booking');

                            if(details.isBookable(unitData)) {
                                const unitCalc = unitData.calc;

                                let total = unitCalc.currencySymbol;
                                let unitTotal = unitCalc ? unitCalc.total : 0;
                                let unitTotalOld = null;

                                 unitCalc.items.forEach(item => {
                                    if(item.itemType == 'baseRate') {
                                        unitTotalOld = item.itemTotal;
                                        if(unitTotalOld > unitTotal) {
                                            total += '<del class="text-danger ml-2">' + functions.formatMoney(unitTotalOld, 0, '.', ',') + '</del>';
                                        }
                                    }
                                });

                                total += '<span class="ml-2">' + functions.formatMoney(unitTotal, 0, '.', ',') + '</span>';

                                $('.unit-price-total[data-unitid=' + unitId + ']').html(total);
                                $('.unit-price-total[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-total-price[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-container[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-error-container[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-payment-type[data-unitid=' + unitId + ']').addClass('d-none');

                                $('.add-item[data-unitid=' + unitId + ']').removeClass('disabled');

                            } else {

                                $('.unit-error-container[data-unitid=' + unitId + ']').removeClass('d-none').html(details.getCalcErrorMessage(detailsTravel.params.calcErrorMessages, unitData));
                                $('.unit-price-container[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-total[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-total-price[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-payment-type[data-unitid=' + unitId + ']').addClass('d-none');

                                $('.add-item[data-unitid=' + unitId + ']').addClass('disabled');

                                $btnBooking.addClass('disabled');
                            }

                        });
                    }

                }, window)).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.btn-booking').addClass('disabled');
        }

    },

    setCalSummary() {
        this.unitsTotal = 0;
        this.unitsTotalOld = 0;

        $('.units-rooms').text('');
        let cart = [];
        this.params.units.forEach((unit, i) => {
            unit.name = $('.unit-name[data-unitid=' + unit.unitId + ']').text();
            this.unitsTotal += unit.total;
            this.unitsTotalOld += unit.totalOld;

            let guests = 0;
            let adults = parseInt(this.params.guests.split(',')[0]);
            let kids = parseInt(this.params.guests.split(',')[1]);
            guests += adults + kids;

            $('.units-rooms').append('<div class="unit-room" data-unitid="' + unit.unitId + '" data-i="' + i + '"><button class="remove-item btn btn-dark px-1 py-0" data-unitid="' + unit.unitId + '"><i class="las la-times-circle la-lg text-danger"></i></button>' + unit.name + ', ' + guests + ' gosta</div>');

            cart.push({
                unitId : unit.unitId,
                dateFrom : this.params.dateFrom,
                dateTo : this.params.dateTo,
                serviceCode : this.params.serviceCode,
                guests : this.params.guests
            })
        });

        $('.units-total').text(functions.formatMoney(this.unitsTotal, 0, '.', ','));
        if(this.unitsTotalOld > this.unitsTotal) {
            $('.units-total-old').text(functions.formatMoney(this.unitsTotalOld, 0, '.', ','));
        } else {
            $('.units-total-old').text('');
        }

        if (cart.length) {
            $('.btn-booking').attr('href',
                $('.btn-booking').attr('href').split('?')[0] +
                '?cart=' + JSON.stringify(cart)
            );

            $('.btn-booking').removeClass('disabled');
        } else {
            $('.btn-booking').addClass('disabled');
            $('.btn-booking').attr('href', $('.btn-booking').attr('href').split('?')[0]);
        }
    },

    loader($target = null) {
        $('.units').addClass('fade');
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 600);
        setTimeout(() => {
            $('.units').removeClass('fade');
        }, 800);
    }

    
};
